import React from 'react'
import { Link } from 'react-router-dom'
import {
  Container,
  Button
} from 'reactstrap'
import Nav from '../../Nav'
import API from '../../../api/index'
import FileBase64 from 'react-file-base64'

const ChangeDNSCreate = () => {
  const [dnsOriginal, setDNSOrigial] = React.useState('')
  const [dnsOriginalMessage, setDNSOrigialMessage] = React.useState('')
  const [dnsChange, setDNSChange] = React.useState('')
  const [dnsChangeMessage, setDNSChangeMessage] = React.useState('')
  const [dateDetection, setDateDetection] = React.useState('')
  const [dateDetectionMessage, setDateDetectionMessage] = React.useState('')
  const [status, setStatus] = React.useState('')
  const [statusMessage, setStatusMessage] = React.useState('')
  const [dateRemediation, setDateRemediation] = React.useState('')
  const [dateRemediationMessage, setDateRemediationMessage] = React.useState('')
  const [images, setImages] = React.useState([])
  const [recommendation, setRecommendation] = React.useState('')
  const [recommendationMessage, setRecommendationMessage] = React.useState('')
  const [messageSuccess, setMessageSuccess] = React.useState('')
  const [risk, setRisk] = React.useState(0)
  const [detectedBy, setDetectedBy] = React.useState('')
  const [evidenceURL, setEvidenceURL] = React.useState('')
  const [evidenceDescription, setEvidenceDescription] = React.useState('')

  function clearMessage() {
    setDNSOrigialMessage('')
    setDNSChangeMessage('')

    setDateDetectionMessage('')
    setDateRemediationMessage('')
    setStatusMessage('')
    setRecommendationMessage('')
    setMessageSuccess('')
  }

  async function handleChangeDNSCreate() {
    clearMessage()
    let data = {
      dns_original: dnsOriginal,
      dns_change: dnsChange,
      date_detection: dateDetection,
      status: status,
      date_remediation: dateRemediation,
      recommendation: recommendation,
      risk: risk,
      screenshots: images,
      detected_by: detectedBy
    }
    if (evidenceURL && evidenceDescription) {
      data['evidences'] = [{
        'url': evidenceURL,
        'description': evidenceDescription
      }]
    }
    const response = await API.dns.create(data)
    if (response.ok) {
      setMessageSuccess(response.message)
    } else if (response.message === 'No es formato JSON') {
      setDNSOrigialMessage('El campo es obligatorio')
      setDNSChangeMessage('El campo es obligatorio')

      setDateDetectionMessage('El campo es obligatorio')
      setStatusMessage('El campo es obligatorio')
    } else {
      if (response.errors.dns_original) {
        setDNSOrigialMessage(response.errors.dns_original[0])
      }
      if (response.errors.dns_change) {
        setDNSChangeMessage(response.errors.dns_change[0])
      }

      if (response.errors.date_detection) {
        setDateDetectionMessage(response.errors.date_detection[0])
      }
      if (response.errors.status) {
        setStatusMessage(response.errors.status[0])
      }
      if (response.errors.recommendation) {
        setRecommendationMessage(response.errors.recommendation[0])
      }
    }
  }

  function getImages(file) {
    if (file.type.split('/')[0] === 'image') {
      setImages([...images, {'name': file.name, 'base64': file.base64}])
    }
  }

  return (
    <div className='layout'>
        <Nav item='changeDNS' />
        <div className='main-content'>
          <div className='header bg-gradient-info pb-8 pt-5 pt-md-6'>
            <Container fluid>
              <Button className='btn-icon btn-3' color='default' type='button'>
                <span className='btn-inner--icon'>
                  <i className='ni ni-bold-left' />
                </span>
                <Link className='btn-inner--text text-white' to='/change-dns'>Volver</Link>
              </Button>
            </Container>
          </div>
          <Container className='mt--7' fluid>
            <div className='content-auto'>
              <div className='card bg-secondary shadow'>
                <div className='card-header bg-white border-0'>
                  <div className='row align-items-center'>
                    <div className='col-8'>
                      <h3 className='mb-0'>Nuevo cambio de DNS</h3>
                      {messageSuccess && (
                        <span className='badge badge-pill badge-success'>{messageSuccess}</span>
                      )}
                    </div>
                    <div className='col-4 text-right'>
                      <span className='btn btn-sm btn-primary text-white' onClick={handleChangeDNSCreate}>Crear un cambio de DNS</span>
                    </div>
                  </div>
                </div>
                <div className='card-body'>
                  <form>
                    <h6 className='heading-small text-muted mb-4'>Información del cambio de DNS</h6>
                      <div className='pl-lg-4'>
                        <div className='row'>
                          <div className='col-lg-6'>
                            <div className='form-group'>
                              <label className='form-control-label'>Registro DNS original</label>
                              <textarea
                                className='form-control form-control-alternative'
                                rows='5'
                                name='dnsOriginal'
                                value={dnsOriginal}
                                onChange={(event) => {
                                  setDNSOrigial(event.target.value)
                                  setDNSOrigialMessage('')
                                }}
                              />
                              {dnsOriginalMessage && (
                                <span className='badge badge-pill badge-danger'>{dnsOriginalMessage}</span>
                              )}
                            </div>
                          </div>
                          <div className='col-lg-6'>
                            <div className='form-group'>
                              <label className='form-control-label'>Registro DNS modificado</label>
                              <textarea
                                className='form-control form-control-alternative'
                                rows='5'
                                name='dnsChange'
                                value={dnsChange}
                                onChange={(event) => {
                                  setDNSChange(event.target.value)
                                  setDNSChangeMessage('')
                                }}
                              />
                              {dnsChangeMessage && (
                                <span className='badge badge-pill badge-danger'>{dnsChangeMessage}</span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-lg-6'>
                            <div className='form-group'>
                              <label className='form-control-label'>Fecha de detección</label>
                              <input
                                type='date'
                                name='dateDetection'
                                className='form-control form-control-alternative'
                                value={dateDetection}
                                onChange={(event) => {
                                  setDateDetection(event.target.value)
                                  setDateDetectionMessage('')
                                }}
                              />
                              {dateDetectionMessage && (
                                <span className='badge badge-pill badge-danger'>{dateDetectionMessage}</span>
                              )}
                            </div>
                          </div>
                          <div className='col-lg-6'>
                            <div className='form-group'>
                              <label className='form-control-label'>Fecha de mitigación</label>
                              <input
                                type='date'
                                name='dateRemediation'
                                className='form-control form-control-alternative'
                                value={dateRemediation}
                                onChange={(event) => {
                                  setDateRemediation(event.target.value)
                                  setDateRemediationMessage('')
                                }}
                              />
                              {dateRemediationMessage && (
                                <span className='badge badge-pill badge-danger'>{dateRemediationMessage}</span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-lg-6'>
                            <div className='form-group'>
                              <label className='form-control-label'>Estado</label>
                              <select
                                className='form-control form-control-alternative'
                                name='status'
                                value={status}
                                onChange={(event) => {
                                  setStatus(event.target.value)
                                  setStatusMessage('')
                                }}
                              >
                                <option value=''>Seleccione un estado</option>
                                <option value='nuevo'>Nuevo</option>
                                <option value='triage'>Triage</option>
                                <option value='investigación'>Investigación</option>
                                <option value='contención'>Contención</option>
                                <option value='cerrado'>Cerrado</option>
                              </select>
                              {statusMessage && (
                                <span className='badge badge-pill badge-danger'>{statusMessage}</span>
                              )}
                            </div>
                          </div>
                          <div className='col-lg-6'>
                            <div className='form-group'>
                              <label className='form-control-label'>Riesgo</label>
                              <input
                                type='int'
                                name='risk'
                                className='form-control form-control-alternative'
                                value={risk}
                                onChange={(event) => {
                                  const value = event.target.value
                                  if (value >= 0 && value <= 100) {
                                    setRisk(value)
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-lg-12'>
                            <div className='form-group'>
                              <label className='form-control-label'>Comentarios del analista</label>
                              <textarea
                                className='form-control form-control-alternative'
                                rows='5'
                                name='recommendation'
                                value={recommendation}
                                onChange={(event) => {
                                  setRecommendation(event.target.value)
                                  setRecommendationMessage('')
                                }}
                              />
                              {recommendationMessage && (
                                <span className='badge badge-pill badge-danger'>{recommendationMessage}</span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-lg-6'>
                            <div className='form-group'>
                              <label className='form-control-label'>Detectado por</label>
                              <input
                                type='text'
                                name='detectedBy'
                                className='form-control form-control-alternative'
                                value={detectedBy}
                                onChange={(event) => {
                                  setDetectedBy(event.target.value)
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-lg-6'>
                            <div className='form-group'>
                              <label className='form-control-label'>Screenshots</label>
                              <div
                                className='form-control form-control-alternative'
                              >
                                <FileBase64 onDone={getImages} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <h3>Evidencia</h3>
                        <div className='row'>
                          <div className='col-lg-6'>
                            <div className='form-group'>
                              <label className='form-control-label'>URL</label>
                              <input
                                type='text'
                                name='evidenceURL'
                                className='form-control form-control-alternative'
                                placeholder='https://www.example.com'
                                value={evidenceURL}
                                onChange={(event) => {
                                  setEvidenceURL(event.target.value)
                                }}
                              />
                            </div>
                          </div>
                          <div className='col-lg-6'>
                            <div className='form-group'>
                              <label className='form-control-label'>Descripción</label>
                              <textarea
                                className='form-control form-control-alternative'
                                rows='5'
                                name='evidenceDescription'
                                value={evidenceDescription}
                                onChange={(event) => {
                                  setEvidenceDescription(event.target.value)
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className='row'>
                          {images.map((image, index) => (
                            <div className='col-lg-3'>
                              <img src={image.base64} alt='finding' key={index} className='img-fluid' />
                            </div>
                          ))}
                        </div>
                      </div>
                  </form>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
  )

}

export default ChangeDNSCreate
